module.exports = __webpack_public_path__ + "img/REC_ENFANT_HOMME_DESACTIVE.9ca8426d.svg";